"use strict";

function findIndex(arr, err) {
  var idx = Infinity;
  arr.some(function (key, ii) {
    if (err.path.indexOf(key) !== -1) {
      idx = ii;
      return true;
    }
  });

  return idx;
}

module.exports = function sortByKeyOrder(fields) {
  var keys = Object.keys(fields);
  return function (a, b) {
    return findIndex(keys, a) - findIndex(keys, b);
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/yup/lib/util/sortByKeyOrder.js
// module id = 1415
// module chunks = 0